import { render, staticRenderFns } from "./CircleMinus.vue?vue&type=template&id=d5977cc0&"
import script from "./CircleMinus.vue?vue&type=script&lang=js&"
export * from "./CircleMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports